import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { keyedColorScheme } from "@/utils/color";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Tag',
    props: {
        option: null,
        search: null,
        editable: { type: Boolean },
        clickable: { type: Boolean }
    },
    emits: ["click", "deleted"],
    setup(__props, { emit }) {
        const props = __props;
        //@ts-ignore bad types
        library.add(faTimes);
        const color = computed(() => keyedColorScheme(props.option));
        function onClick() {
            emit("click", props.option);
        }
        function onDelete() {
            emit("deleted", props.option);
        }
        const named = computed(() => { var _a; return (_a = props.option) === null || _a === void 0 ? void 0 : _a.startsWith("#"); });
        const searched = computed(() => { var _a, _b; return ((_a = props.option) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === ((_b = props.search) === null || _b === void 0 ? void 0 : _b.toLowerCase()); });
        return { __sfc: true, props, emit, color, onClick, onDelete, named, searched, FontAwesomeIcon };
    }
});
